import * as React from 'react';

const CreditIcon = ({
  color = '#fff',
  className,
}: {
  color?: string;
  className?: string;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="10"
    height="10"
    viewBox="0 0 10 10"
    fill="none"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.90757 0.84393C4.03475 0.357708 4.47551 0 5 0C5.52449 0 5.96525 0.357699 6.09243 0.843921C6.32256 1.7237 6.69074 2.37193 7.17476 2.85091C7.65906 3.33015 8.31416 3.69418 9.20263 3.91956C9.66326 4.03641 10 4.45209 10 4.94446C10 5.50096 9.62167 5.96673 9.10996 6.10468C8.24635 6.3375 7.60865 6.70541 7.13638 7.18769C6.6636 7.6705 6.30389 8.32179 6.08044 9.20263C5.96359 9.66324 5.54794 10 5.05554 10C4.49904 10 4.03327 9.62167 3.89532 9.10995C3.6625 8.24635 3.2946 7.60865 2.81232 7.13638C2.32952 6.6636 1.67822 6.3039 0.797368 6.08044C0.336767 5.96359 0 5.54795 0 5.05554C0 4.49904 0.378334 4.03327 0.890048 3.89532C1.74619 3.66452 2.38014 3.30098 2.85091 2.82525C3.32193 2.34926 3.68139 1.7086 3.90757 0.84393Z"
      fill={color}
    />
  </svg>
);

export default CreditIcon;
